import { defineStore } from 'pinia';
import { type StationMRUEntries, useStationMRUStore } from '@/stores/stationMRU.ts';
import { getHaltestelleId, type HaltestelleWithQuelle } from '@/model/haltestelle.ts';
import { useReiseBegleitungStore } from '@/stores/reiseBegleitung.ts';
import type { IdentifikationDto } from '@/model/dto/IdentifikationDto.ts';
import { Quelle } from '@/model/quelle.ts';

export interface MigrationState {
  reiseBegleitung_Startzeit: boolean | undefined;
  stationMRU_HaltestelleWithQuelle: boolean | undefined;
}

export const useMigrationStore = defineStore('migration', {
  state: (): MigrationState => ({
    reiseBegleitung_Startzeit: false,
    stationMRU_HaltestelleWithQuelle: false,
  }),
  persist: true,
  actions: {
    async executeMigrations() {
      if (this.stationMRU_HaltestelleWithQuelle !== true) {
        const stationMRUStore = useStationMRUStore();
        // noinspection UnnecessaryLocalVariableJS
        const migratedMRU: StationMRUEntries = Object.values(stationMRUStore.stations).reduce((mru, entry) => {
          const haltestelle: HaltestelleWithQuelle = {
            ...entry.station,
            quelle: entry.station.quelle !== undefined ? entry.station.quelle : Quelle.DB_NAVIGATOR,
          };
          mru[getHaltestelleId(haltestelle)] = {
            station: haltestelle,
            lastUsed: entry.lastUsed,
            timesUsed: entry.timesUsed,
          };
          return mru;
        }, {} as StationMRUEntries);
        stationMRUStore.stations = migratedMRU;
        this.stationMRU_HaltestelleWithQuelle = true;
      }
      if (this.reiseBegleitung_Startzeit !== true) {
        const reiseBegleitungStore = useReiseBegleitungStore();
        // noinspection UnnecessaryLocalVariableJS
        const migratedAllReiseIdDto: IdentifikationDto[] = reiseBegleitungStore.allReiseIdDto.map((identifikation) => ({
          reiseId: identifikation.reiseId,
          reiseQuelle: identifikation.reiseQuelle,
          startZeit: identifikation.startZeit !== undefined ? identifikation.startZeit : Date.now(),
        }));
        reiseBegleitungStore.allReiseIdDto = migratedAllReiseIdDto;
        this.reiseBegleitung_Startzeit = true;
      }
    },
  },
});
